module.exports = __webpack_public_path__ + "_assets/img/coin.2d2ead0f.svg";